(function () {
  function initNoibuHelpCode() {
    const button = document.getElementById('request-help-code');
    const result = document.getElementById('help-code-result');

    if (!button || !result || button.dataset.noibuHelpCodeInit === 'true') {
      return;
    }

    button.dataset.noibuHelpCodeInit = 'true';

    button.addEventListener('click', async function () {
      if (!window.NOIBUJS || typeof window.NOIBUJS.requestHelpCode !== 'function') {
        return;
      }

      try {
        const helpCode = await window.NOIBUJS.requestHelpCode(false);
        result.innerText = helpCode;
      } catch (error) {
        console.error('Noibu help code request failed:', error);
      }
    });
  }

  function onNoibuReady() {
    initNoibuHelpCode();
  }

  if (window.NOIBUJS) {
    onNoibuReady();
  } else {
    window.addEventListener('noibuSDKReady', onNoibuReady);
  }
})();
